import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NavigateRoutes, NetworkSpeedMsg, RequestType, StatementType, StorageConstants, TransactionStatus } from 'common/constants/app.constant';
import { register } from 'swiper/element/bundle';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { DeviceService } from 'common/services/core_services/device.service';
import { SystemService } from 'common/services/core_services/system.service';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';
import { StorageService } from 'common/services/core_services/storage.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { Platform } from '@ionic/angular';
import { SideMenuItem, SideMenuModel } from 'common/models/utilitymodels/menu.model';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppWidgetService } from 'common/services/component_services/appService/appService.widget.service';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import configAndroid from 'capacitor.config.android';
import configIos from 'capacitor.config.ios';
import { QueryParams } from 'common/models/utilitymodels/list.model';
import { App, AppLaunchUrl } from '@capacitor/app';
import { DOCUMENT } from '@angular/common';
import { AppCrashlyticsService } from 'common/services/core_services/app-crashlytics.service';
import { initializeApp } from 'firebase/app';
import { environment } from 'common/environment/environment.dev';
import SmartechBaseCordova from 'smartech-base-cordova';
import SmartechPushCordova from 'smartech-push-cordova';
import { LoadingService } from 'common/services/core_services/loading.service';
register();
@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
})
export class AppComponent implements OnInit, AfterViewInit {
    innerWidth = window.innerWidth;
    loading: boolean = false;
    backButtonPressed: boolean = false;
    isOffline: boolean = false;
    initialLoadOffline: boolean = false;
    currentActiveUrl: string = '';
    sideMenuItems = new SideMenuModel().sideMenuInfo;
    showTabsAndSideBar: boolean = true;
    rightPageToShowSidebar: boolean = false;
    hideFooter: boolean = false;
    userActivity: any;
    userInactive: Subject<any> = new Subject();
    isWebBackButtoClick: boolean = false;
    showModal: boolean = false;
    msg: string = 'Update Available';
    isMajorUpdate: boolean = false;
    initialLoadUTM: boolean = true;

    constructor(
        protected systemService: SystemService,
        private deviceService: DeviceService,
        private router: Router,
        private storageService: StorageService,
        private cdr: ChangeDetectorRef,
        private platform: Platform,
        private modalService: NgbModal,
        private widService: AppWidgetService,
        @Inject(DOCUMENT) protected document: Document,
        private appCrashlyticsService: AppCrashlyticsService,
        private zone: NgZone,
        private activatedRoute: ActivatedRoute
    ) {
        this.platform.ready().then(() => {
            SplashScreen.hide().then().catch();
            window.addEventListener('keyboardWillShow', () => {
                const el = document.getElementById('hideOnKeyboardOpen');
                const bottomBars = document.getElementsByClassName('app-bottom-tabs')[0];
                const outletEl = document.querySelector('.app-router-outlet');
                if (el !== null) el.classList.add('d-none');
                if (bottomBars !== null) bottomBars.classList.add('neg-z-index');
                if (outletEl !== null) outletEl.classList.add('no-height');
                document.activeElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                // if (window.innerWidth > 992) {
                //     document.body.classList.add('neg-06');
                // }
            });
            window.addEventListener('keyboardWillHide', () => {
                const el = document.getElementById('hideOnKeyboardOpen');
                const bottomBars = document.getElementsByClassName('app-bottom-tabs')[0];
                const outletEl = document.querySelector('.app-router-outlet');
                if (el !== null) el.classList.remove('d-none');
                if (bottomBars !== null) bottomBars.classList.remove('neg-z-index');
                if (outletEl !== null) outletEl.classList.remove('no-height');
                // if (window.innerWidth > 992) {
                //     document.body.classList.remove('neg-06');
                // }
            });
        });

        this.deviceService
            .getDeviceInfo()
            .then((info) => {
                this.systemService.deviceInfo = info;
                if (info.platform !== 'web') {
                    this.addNetCoreLisner();
                    this.onAppOpened();
                    this.platform.resume.subscribe((value) => {
                        App.addListener('appUrlOpen', async (data: any) => {

                            if (data !== undefined) {
                                this.redirectAppLinks(data?.url, true);
                            }
                        });
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    onAppOpened() {
        App.addListener('appUrlOpen', (data: any) => {
            if (data !== undefined) {
                this.redirectAppLinks(data?.url);
            }
        });
    }

    saveQueryParams(url: string) {
        const urlArray = url.split('?');
        this.initialLoadUTM = false;
        if (urlArray.length > 1) {
            const paramStr = urlArray[1].split('&');
            this.systemService.utmParams = {};
            for (let item of paramStr) {
                const keyVal: string[] = item.split("=");
                this.systemService.utmParams[keyVal[0]] = keyVal[1];
            }
        }
    }

    async ngOnInit() {
        this.setOnlineOfflineMessage(navigator.onLine, true);
        if (!navigator.onLine) {
            this.initialLoadOffline = true;
        }
        this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationStart) {
                this.currentActiveUrl = event.url;
                if (this.initialLoadUTM) {
                    this.saveQueryParams(event.url);
                }
            }

            if (event instanceof NavigationEnd) {
                const scrollEl = document.querySelector('.app-router-outlet');
                if (scrollEl !== null) {
                    scrollEl.scrollTo(0, 0);
                }

                if (event.url === NavigateRoutes.distributorprofile && !this.systemService.getLocalStorage(StorageConstants.userProfile)) {
                    this.showTabsAndSideBar = false;
                } else {
                    this.showTabsAndSideBar = true;
                }

                location.pathname.includes('/distributor') && this.systemService.getLocalStorage(StorageConstants.userProfile) !== null ? (this.rightPageToShowSidebar = true) : (this.rightPageToShowSidebar = false);

                this.cdr.detectChanges();
            }
        });
        await this.storageService.createStorage();
        this.systemService.deviceId = await this.deviceService.getDeviceId();

        this.systemService.loading.subscribe((loading) => {
            this.loading = loading;
            // this.cdr.detectChanges();
        });

        if (this.systemService.deviceInfo.platform !== 'web') {
            this.checkVersionUpdate();
        }

        if (this.systemService.deviceInfo.platform === 'ios') {
            if (parseInt(this.systemService.deviceInfo?.osVersion) < 18) {
                document.documentElement.classList.add('plt_ios_old');
            }
            // this.checkVersionUpdate();
        }
        this.setAppFeatures();
        this.setRouterEvents();
        this.setDeviceRouting();
        this.checkOnlineOffline();
        this.isPreLoginCheck();
        this.addVidioSrcipt();
        this.appCrashlyticsInit();

        if (!this.systemService.getLocalStorage(StorageConstants.ipAddress)) {
            this.getIpAddress();
        }
    }

    ngOnDestroy() {
        SmartechBaseCordova.removeListener(SmartechBaseCordova.SmartechDeeplink, this.handleDeeplinkWithPayload);
        SmartechPushCordova.removeListener(SmartechPushCordova.SmartechNotificationReceived, this.handleNotificationReceived);
    }

    redirectAppLinks(url: string, navigateWithoutDelay: boolean = false) {
        this.zone.run(async () => {
            // Example url: https://beerswift.app/tabs/tab2
            // slug = /tabs/tab2
            const slug = url.split('.com').pop();
            if (slug) {
                // this.router.navigateByUrl(slug);
                this.currentActiveUrl = slug;
                this.setDeviceRouting();
                // if (navigateWithoutDelay) {
                //     const redirectConfig = this.systemService.getRouteDetailsFromUrl(slug);
                //     this.systemService.routeByUrl(redirectConfig.url, redirectConfig.message);
                // } else {
                //     const redirectConfig = this.systemService.getRouteDetailsFromUrl(slug);
                //     this.systemService.routeByUrl(redirectConfig.url, redirectConfig.message);
                // }
            }
            // If no match, do nothing - let regular routing
            // logic take over
        });
    }

    addNetCoreLisner() {
        SmartechBaseCordova.addListener(SmartechBaseCordova.SmartechDeeplink, this.handleDeeplinkWithPayload);
    }

    handleNotificationReceived = (smartechData: any) => {
        // console.log('Smartech Data :: ', JSON.stringify(smartechData));
    };

    handleDeeplinkWithPayload = (smartechData: any) => {
        let finalUrl = smartechData.smtDeeplink?.split('.com')[1] || '';
        if (finalUrl.includes('?')) {
            finalUrl = finalUrl.split('?')[0];
        }

        if (location.pathname.startsWith('/login') || location.pathname.startsWith('/empanelment')) {
            this.redirectAppLinks(finalUrl, false);
        } else {
            this.redirectAppLinks(finalUrl, true);
        }
    };

    navigateTo = async () => {
        if (this.systemService.getSesstionStorage(StorageConstants.deepLinkDetails)) {
            const routeDetails = JSON.parse(this.systemService.getSesstionStorage(StorageConstants.deepLinkDetails));
            await this.systemService.openInternalPage(routeDetails);
            this.systemService.removeSessionStorage(StorageConstants.deepLinkDetails);
            return;
        }
    };

    getIpAddress() {
        this.widService.getIPAddres().then((data) => {
            this.systemService.setLocalStorage(StorageConstants.ipAddress, data);
        });
    }

    appCrashlyticsInit() {
        try {
            initializeApp(environment.firebaseConfig);
            if (this.systemService.deviceInfo.platform !== 'web') {
                this.appCrashlyticsService.initializeCrashlytics();
            }
            this.appCrashlyticsService.initFirePerformace();
        } catch (err) {

            console.log("Firebase", err);
        }

    }

    isPreLoginCheck() {
        if (this.systemService.getSesstionStorage(StorageConstants.isPreLoginInitiat)) {
            this.systemService.isPriLoginTransaction = true;
        } else {
            this.systemService.isPriLoginTransaction = false;
        }
    }

    closeModal(event: boolean) {
        this.showModal = false;
        this.systemService.dismissPopup();
    }

    isServerUnderMentanance() {
        this.widService
            .getDataOfAppState()
            .then((data: any) => {
                const maintainance = data.find((ele: any) => ele.id === 3);
                if (maintainance) this.systemService.underMaintenance = maintainance.maintainance;
            })
            .catch((error) => {
                this.systemService.loading.next(false);
                this.systemService.showToaster('Something Went Wrong', 'error');
            });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
        const deviceData = this.calculateDeviceWidth();
        const errDiv: any = document.getElementById('error-div');
        if (this.systemService.deviceInfo.platform === 'web' && (deviceData.deviceWidth <= 575 || deviceData.deviceHeight <= 575)) {
            if (deviceData.deviceInfo.angle === 90 || deviceData.deviceInfo.angle === -90 || deviceData.deviceInfo.angle === 270) {
                errDiv.classList.remove('hide-modal');
            } else {
                errDiv.classList.add('hide-modal');
            }
        } else {
            errDiv.classList.add('hide-modal');
        }
    }

    private calculateDeviceWidth(): any {
        const deviceWidth = window.innerWidth;
        const deviceHeight = window.innerHeight;
        const deviceInfo = screen?.orientation ? screen.orientation : window.screen.orientation;
        return {
            deviceWidth,
            deviceHeight,
            deviceInfo,
        };
    }

    checkVersionUpdate() {
        this.widService
            .getDataOfAppState()
            .then((data: any) => {
                const android = data.find((ele: any) => ele.id === 1);
                const ios = data.find((ele: any) => ele.id === 2);
                if (Capacitor.isNativePlatform()) {
                    App.getInfo().then((info: any) => {
                        let versionArr: any = info.version.split('.');

                        versionArr = versionArr.slice(0, 2);
                        if (versionArr.length === 1) {
                            versionArr.push('00');
                        }

                        if (versionArr[1].length === 1) {
                            versionArr[1] += '0';
                        }
                        // cms android version
                        let andVer: any = android.standardVersion.split('.');
                        andVer = andVer.slice(0, 2);

                        if (andVer.length === 1) {
                            andVer.push('00');
                        }

                        if (andVer[1].length === 1) {
                            andVer[1] += '0';
                        }
                        // // cms ios version
                        let iosVer: any = ios.standardVersion.split('.');
                        iosVer = iosVer.slice(0, 2);

                        if (iosVer.length === 1) {
                            iosVer.push('00');
                        }

                        if (iosVer[1].length === 1) {
                            iosVer[1] += '0';
                        }

                        if (this.systemService.deviceInfo.platform === 'android') {
                            if (+andVer[0] > +versionArr[0]) {
                                this.isMajorUpdate = true;
                                this.msg = `Android major update is available, current version is ${info.version} and latest version is ${android.standardVersion} Update your app to continue.`;
                                this.showModal = true;
                            } else if (+andVer[0] == +versionArr[0] && +andVer[1].charAt(0) > +versionArr[1].charAt(0)) {
                                this.isMajorUpdate = true;
                                this.msg = `Android major update is available, current version is ${info.version} and latest version is ${android.standardVersion} Update your app to continue.`;
                                this.showModal = true;
                            } else if (+andVer[0] == +versionArr[0] && +andVer[1].charAt(0) === +versionArr[1].charAt(0) && +andVer[1].charAt(1) > +versionArr[1].charAt(1)) {
                                this.isMajorUpdate = false;
                                this.msg = `Android minor update is available, current version is ${info.version} and latest version is ${android.standardVersion}, Do you want to update your application ?`;
                                this.showModal = true;
                            } else {
                                this.isMajorUpdate = false;
                                this.showModal = false;
                            }
                        } else if (this.systemService.deviceInfo.platform === 'ios') {
                            if (+iosVer[0] > +versionArr[0]) {
                                this.isMajorUpdate = true;
                                this.msg = `IOS major update is available, current version is ${info.version} and latest version is ${ios.standardVersion} Update your app to continue.`;
                                this.showModal = true;
                            } else if (+iosVer[0] == +versionArr[0] && +iosVer[1].charAt(0) > +versionArr[1].charAt(0)) {
                                this.isMajorUpdate = true;
                                this.msg = `IOS major update is available, current version is ${info.version} and latest version is ${ios.standardVersion} Update your app to continue.`;
                                this.showModal = true;
                            } else if (+iosVer[0] == +versionArr[0] && +iosVer[1].charAt(0) === +versionArr[1].charAt(0) && +iosVer[1].charAt(1) > +versionArr[1].charAt(1)) {
                                this.isMajorUpdate = false;
                                this.msg = `IOS minor update is available, current version is ${info.version} and latest version is ${ios.standardVersion}, Do you want to update your application ?`;
                                this.showModal = true;
                            } else {
                                this.isMajorUpdate = false;
                                this.showModal = false;
                            }
                        }
                    });
                }
            })
            .catch((error) => {
                this.systemService.showToaster('Something Went Wrong', 'error');
            })
            .finally(() => {
                this.systemService.loading.next(false);
            });
    }

    openAppStore() {
        if (Capacitor.isNativePlatform()) {
            if (this.systemService.deviceInfo.platform === 'android') {
                const marketplaceUrl = `https://play.google.com/store/apps/details?id=${configAndroid.appId}`;
                Browser.open({ url: marketplaceUrl, windowName: '_blank' });
            } else if (this.systemService.deviceInfo.platform === 'ios') {
                const marketplaceUrl = `https://apps.apple.com/us/app/${configIos.appId}`;
                Browser.open({ url: marketplaceUrl, windowName: '_blank' });
            }
        }
    }

    ngAfterViewInit(): void {
        const ss = this.systemService;
        this.isServerUnderMentanance();
        screen.orientation.addEventListener('change', function () {
            const angle = screen.orientation.angle || window.orientation;
            try {
                if (!(angle === 90 || angle === -90 || angle === 270)) {
                    ss.minimizedSideBar = false;
                }
            } catch (e) {
                ss.showToaster('error in orientation detection', 'error');
            }
        });
    }

    async setDeviceRouting() {
        if (this.isWebBackButtoClick) {
            return;
        }
        const redirectConfig = this.systemService.getRouteDetailsFromUrl(this.currentActiveUrl);
        if (redirectConfig.message !== null) {
            this.systemService.routeByUrl(redirectConfig.redirectUrl, redirectConfig.message);
            return;
        } else {
            this.systemService.removeSessionStorage(StorageConstants.redirectionUrl);

            if (this.systemService.deviceInfo.platform === 'web') {
                console.log(JSON.parse(this.systemService.getSesstionStorage(StorageConstants.currentPageState)).pageURL, this.currentActiveUrl, 'cureent PageStaete');
                let routeMessage = new RouteMessage();
                if (this.systemService.getSesstionStorage(StorageConstants.currentPageState) && this.currentActiveUrl === JSON.parse(this.systemService.getSesstionStorage(StorageConstants.currentPageState)).pageURL) {
                    const routeData = JSON.parse(this.systemService.getSesstionStorage(StorageConstants.currentPageState));
                    routeMessage = routeData;
                    this.systemService.routeByUrl(routeData.pageURL, routeMessage);
                    return;
                }
            }
            if (this.systemService.deviceInfo.platform !== 'web') {
                const routeMessage = new RouteMessage();
                if (this.systemService.getLocalStorage(StorageConstants.userProfile) && this.systemService.getLocalStorage(StorageConstants.userProfile) !== 'null') {
                    await this.storageService.clearStorage();
                    routeMessage.type = RequestType.BLANK;
                    this.systemService.routeByUrl(NavigateRoutes.loginViaOtp, routeMessage);
                    return;
                } else {
                    routeMessage.type = RequestType.GET;
                    this.systemService.routeByUrl(NavigateRoutes.welcome, routeMessage);
                    return;
                }

            }


        }




    }

    setAppFeatures() {
        if (this.isWebBackButtoClick) {
            return;
        }
        if (this.systemService.deviceInfo.platform !== 'web') {
            // @ts-ignore
            window.screen.orientation.lock('portrait').then().catch();
            // screen.orientation.angle || window.orientation;
            Keyboard.setResizeMode({
                mode: KeyboardResize.Body,
            })
                .then()
                .catch();
        } else {
            window.addEventListener('keyboardDidShow', (event) => {
                const element: any = document.activeElement;
                element.scrollIntoView({ block: 'center' });
            });
        }
    }

    setRouterEvents() {
        if (this.isWebBackButtoClick) {
            return;
        }
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (this.systemService.deviceInfo.platform === 'web') {
                    if (!this.backButtonPressed) {
                        if (event.navigationTrigger !== 'popstate') {
                            // window.history.pushState({}, '', window.location.href);
                        }
                    }
                }
            }
            if (event instanceof NavigationEnd) {
                if (event.url.startsWith('/distributor/dashboard')) {
                    // window.history.pushState(null, '', null);
                }
                if (this.systemService.getLocalStorage(StorageConstants.userProfile)) {
                    this.systemService.isTransactionRouteForPopup =
                        event.url.startsWith('/distributor/transact') &&
                            !event.url.startsWith(NavigateRoutes.transactionThankYou) &&
                            !event.url.startsWith(NavigateRoutes.initiateTransaction) &&
                            !event.url.startsWith(NavigateRoutes.selectInvestor) &&
                            !event.url.startsWith(NavigateRoutes.transactionHistory) &&
                            !event.url.startsWith(NavigateRoutes.transactionDetails) &&
                            !event.url.startsWith(NavigateRoutes.pendingTransaction) &&
                            !event.url.startsWith(NavigateRoutes.otm) &&
                            !event.url.startsWith(NavigateRoutes.contactDetails)
                            ? true
                            : false;
                }
            }
        });
    }

    checkOnlineOffline() {
        window.addEventListener('offline', () => {
            this.setOnlineOfflineMessage(false, false);
        });
        window.addEventListener('online', () => {
            this.setOnlineOfflineMessage(true, false);
            if (this.initialLoadOffline) {
                this.setDeviceRouting();
                this.initialLoadOffline = false;
            }
        });
    }

    setOnlineOfflineMessage(online: boolean, fromNavigator: boolean) {
        !online ? document.body.classList.add('fix-screen') : document.body.classList.remove('fix-screen');
        this.isOffline = !online;
        this.systemService.isOnline.next(online);
        this.cdr.detectChanges();
        if (!fromNavigator) {
            this.systemService.showToaster(online ? NetworkSpeedMsg.online : NetworkSpeedMsg.offline, online ? 'success' : 'error');
        }
    }

    toggleSidePanelInLG() {
        this.systemService.minimizedSideBar = !this.systemService.minimizedSideBar;
    }

    // deepLinkNavigate(url: string) {
    //     const sideMenuInfo: SideMenuItem[] = new SideMenuModel().sideMenuInfo;
    //     let deepLinkRouteDetails: any = null;
    //     const userData = JSON.parse(this.systemService.getLocalStorage(StorageConstants.userProfile));
    //     let isNavigate: boolean = true;
    //     if (userData && userData?.type !== 'NON_IFA_USER') {
    //         const result = this.setRestrictedRouteNavigation(url);
    //         if (result !== null) {
    //             deepLinkRouteDetails = result;
    //         }
    //     }

    //     if (typeof userData === 'undefined' || userData === null) {
    //         const result = this.setRestrictedRouteNavigation(url);
    //         if (result !== null) {
    //             deepLinkRouteDetails = result;
    //         }
    //     }

    //     if (deepLinkRouteDetails === null) {
    //         const subLink = url.substring(0, url.lastIndexOf('/'));
    //         for (let routes of sideMenuInfo) {
    //             if (userData && userData.type === 'NON_IFA_USER') {
    //                 if ([NavigateRoutes.distributordashboard, NavigateRoutes.oppotunity, NavigateRoutes.statement, NavigateRoutes.brokeragereport, NavigateRoutes.wishes].includes(routes.url)) {
    //                     isNavigate = false;
    //                 } else {
    //                     isNavigate = true;
    //                 }
    //             }

    //             if (routes.subItems.length > 0) {
    //                 for (let subItems of routes.subItems) {
    //                     if (isNavigate && subItems.isdeepLink && subItems.url === url) {
    //                         deepLinkRouteDetails = subItems;
    //                     } else if (isNavigate && subItems.isdeepLink && subItems.url === subLink) {
    //                         deepLinkRouteDetails = subItems;
    //                     }
    //                 }
    //             }
    //             if (isNavigate && deepLinkRouteDetails === null && routes.url === url) {
    //                 deepLinkRouteDetails = routes;
    //             } else if (isNavigate && deepLinkRouteDetails === null && routes.url === subLink) {
    //                 deepLinkRouteDetails = routes;
    //             }
    //         }
    //     }

    //     if (deepLinkRouteDetails !== null) {
    //         this.systemService.setSessionStorage(StorageConstants.deepLinkDetails, JSON.stringify(deepLinkRouteDetails));
    //     }
    // }

    // setRestrictedRouteNavigation(url: string = '') {
    //     if (url.includes('opportunity')) {
    //         this.onOpportunityDeepLink(url);
    //         return null;
    //     } else if (url.endsWith('/transact/investor-list/account-statement')) {
    //         return {
    //             id: 1,
    //             name: 'Account Statement',
    //             url: NavigateRoutes.accountStatement,
    //             routerData: {
    //                 statement: true,
    //                 typeofStatement: StatementType.account,
    //             },
    //             subItems: [],
    //             requestType: RequestType.ID,
    //             selected: false,
    //             show: true,
    //             isdeepLink: true,
    //         };
    //     } else if (url.endsWith('/transact/investor-list/capital-gain-statement')) {
    //         return {
    //             id: 2,
    //             name: 'Capital Gain Statement',
    //             url: NavigateRoutes.capitalGainStatement,
    //             routerData: {
    //                 statement: true,
    //                 typeofStatement: StatementType.capitalGain,
    //             },
    //             subItems: [],
    //             requestType: RequestType.ID,
    //             selected: false,
    //             show: true,
    //             isdeepLink: true,
    //         };
    //     } else {
    //         return null;
    //     }
    // }

    // onOpportunityDeepLink(url: string): any {
    //     let oppData: any = [];
    //     const sipOppData: SIPOpportuinityItem[] = new SIPOpportunityModel().listInfo;
    //     const crossOppData: CrossSellOpportuinityItem[] = new CrossSellOpportunityModel().listInfo;
    //     const activeOppData: ActivationOpportuinityItem[] = new ActivationOpportunityModel().listInfo;
    //     const otherOppData: OtherOpportuinityItem[] = new OtherOpportunityModel().listInfo;
    //     const oppDataList: OpportuinityItem[] = new OpportunityMetaModel().OpportuinityInfo;

    //     oppData = [...sipOppData, ...crossOppData, ...activeOppData, ...otherOppData, ...oppDataList];
    //     for (let sipOpp of oppData) {
    //         if (sipOpp.url === url) {
    //             const modifyOpp = sipOpp;
    //             modifyOpp.deepLink = true;
    //             const routeMsg = new RouteMessage();
    //             routeMsg.type = ['SIP Opportunities', 'CROSS SELL OPPORTUNITIES', 'ACTIVATION OPPORTUNITIES', 'OTHER OPPORTUNITIES'].includes(sipOpp.name) ? RequestType.ID : RequestType.GET;
    //             routeMsg.transferData = modifyOpp;
    //             return routeMsg;
    //         }
    //     }

    // }

    addVidioSrcipt() {
        const existingEle = this.document.getElementById('vidioScriptID');
        if (!existingEle) {
            const element = this.document.createElement('script');
            element.type = 'text/javascript';
            element.id = 'vidioScriptID';
            element.src = 'https://www.youtube.com/iframe_api';
            this.document.head.appendChild(element);
        }
    }




}
